import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Footer = () => {
  const { t: translate } = useTranslation();
  const currentLang = useSelector((state) => state.language.lang) || 'tr';

  const getCategoriesPath = (langCode) => {
    return langCode === 'tr' ? 'kategoriler' : 'categories';
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(10px)',
        boxShadow: '3px -3px 10px rgba(0, 0, 0, 0.1)',
        py: 1,
        px: { xs: 1, md: 3 },
        position: 'fixed',
        bottom: 0,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: { xs: 1, md: 2 },
          width: '100%',
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1.5, md: 3 },
            alignItems: 'center',
          }}
        >
          <MuiLink
            component={RouterLink}
            to={`/${currentLang}/${getCategoriesPath(currentLang)}`}
            sx={{
              fontSize: { xs: '0.75rem !important', md: '0.850rem !important' },
              fontWeight: 500,
              color: 'rgba(128, 128, 128, 0.9)',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': {
                color: 'rgba(100, 100, 100, 0.9)',
              },
            }}
          >
            {translate('footer.categories')}
          </MuiLink>

          <MuiLink
            component={RouterLink}
            to={`/${currentLang}/${currentLang === 'tr' ? 'gizlilik-politikasi' : 'privacy-policy'}`}
            sx={{
              color: 'rgba(128, 128, 128, 0.9) !important',
              fontSize: { xs: '0.75rem !important', md: '0.850rem !important' },
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': {
                color: 'rgba(100, 100, 100, 0.9)',
              },
            }}
          >
            {translate('footer.privacy_policy')}
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to={`/${currentLang}/${currentLang === 'tr' ? 'kullanim-sartlari' : 'terms-and-conditions'}`}
            sx={{
              color: 'rgba(128, 128, 128, 0.9) !important ',
              textDecoration: 'none',
              fontSize: { xs: '0.75rem !important', md: '0.850rem !important' },
              fontWeight: 500,
              transition: 'color 0.2s ease',
              '&:hover': {
                color: 'rgba(100, 100, 100, 0.9)',
              },
            }}
          >
            {translate('footer.terms_and_conditions')}
          </MuiLink>
        </Box>
        <Typography
          sx={{
            fontSize: { xs: '0.7rem', md: '0.8rem' },
            fontWeight: 500,
            color: 'rgba(128, 128, 128, 0.9)',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © {new Date().getFullYear()} Coaching Search Engine. {translate('footer.all_rights_reserved')}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
